import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Thunk to fetch daily photo
export const fetchDailyPhotoContestData = createAsyncThunk(
    'dailyPhotoContest/fetch',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get('/api/daily-photo-contest');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Thunk to submit guess
export const submitDailyPhotoContestGuess = createAsyncThunk(
    'dailyPhotoContest/submitGuess',
    async ({ answer }, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/daily-photo-contest/guess', {
                answer
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
); 